import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
//import { useHolidayListContext } from "context/HolidayListContext";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { months, daysOfWeek } from "constant";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import HolidayFormModal from "./HolidayFormModal";
import DeleteHolidayModal from "./DeleteHolidayModal";
//import editIcon from "../../../assets/img/edit-icon.png";
import { Button, Modal, Form } from "react-bootstrap";
import CrossIcon from "../../../assets/img/file-cut-icon.png";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";

import {
  updateHoliday,
  createHoliday,
  publishHoliday,
  deleteHoliday,
  HRViewHoliday,
  getHolidayById,
  listOfCalendar,
  setSelectedEditYear,
} from "../../../redux/slice/getAllHolidaySlice";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { useParams } from 'react-router-dom';
const PublishHoliday = () => {
  const loading = useSelector(
    (state) => state.allHolidayData.loading
  );
  const error = useSelector(
    (state) => state.allHolidayData.error
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { year: urlYear } = useParams();
  const initialYear = urlYear ? parseInt(urlYear, 10) : new Date().getFullYear();

  /* ================= Permissions ================= */
  const canManageHoliday = useHasPermission("Holiday-manage");
  const canDeleteHoliday = useHasPermission("Holiday-delete");
  const canManagePublishHoliday = useHasPermission("Holiday-Publish-manage");
  const canDeletePublishHoliday = useHasPermission("Holiday-Publish-delete");

  const [year, setYear] = useState(initialYear);
  const [showFormModal, setShowFormModal] = useState(false);
  const [formMode, setFormMode] = useState("add");
  const [formData, setFormData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [holidayToDelete, setHolidayToDelete] = useState(null);
  const [expandedHoliday, setExpandedHoliday] = useState(null);

  const toggleHoliday = (id) => {
    setExpandedHoliday((prevId) => (prevId === id ? null : id));
  };

  const AllHoliday = useSelector((state) => state.allHolidayData.HRViewHoliday.holidayResponseDtos);
  const HolidayStatus = useSelector((state) => state.allHolidayData.HRViewHoliday.status);
  useEffect(() => {
    //console.log("FETCH API CALLED");
    dispatch(HRViewHoliday(year));
  }, [year, dispatch]);

  useEffect(() => {
    dispatch(listOfCalendar(year));
  }, [year, dispatch]);

  const calendarList = useSelector(
    (state) => state.allHolidayData.calendarList || []
  );

  // console.log('calendarListlength-----------------------------', calendarList?.length);
  // console.log("calendarList =>", calendarList);
  // console.log("type =>", typeof calendarList);
  const getDayOfWeek = (dateString) => {
    const days = [
      "SUNDAY",
      "MONDAY",
      "TUESDAY",
      "WEDNESDAY",
      "THURSDAY",
      "FRIDAY",
      "SATURDAY",
    ];
    return days[new Date(dateString).getDay()];
  };

  const handleAddHolidaySubmit = async () => {
    const holidayData = {
      holidayName: title,
      holidayDescription: description,
      holidayDate: toDate,
      dayOfHoliday: getDayOfWeek(toDate),
      holidayType: holidayType,
      isMandatory: true,
    };
    try {
      const result = await dispatch(createHoliday(holidayData));
      if (createHoliday.fulfilled.match(result)) {
        dispatch(HRViewHoliday(year));
        setShowEditModal(false);
        resetForm();
      } else {
        toast.error(result?.payload?.message || result?.error?.message || "Failed to create holiday", { className: "toast-error-custom" });
      }
    } catch (error) {
      console.log(error);
      toast.error(error || "Something went wrong", { className: "toast-error-custom" });
    }
  };

  const selectedHoliday = useSelector(
    (state) => state.allHolidayData.selectedHoliday,
  );
  useEffect(() => {
    if (selectedHoliday) {
      setTitle(selectedHoliday.holidayName || "");
      setToDate(selectedHoliday.holidayDate || "");
      setHolidayType(selectedHoliday.holidayType || "");
      setDescription(selectedHoliday.holidayDescription || "");
      setEditHolidayId(selectedHoliday.id);
      setIsEditMode(true);
      setShowEditModal(true);
    }
  }, [selectedHoliday]);

  const handleUpdateHoliday = async () => {
    //console.log("UPDATE BUTTON CLICKED");
    const holidayData = {
      holidayName: title,
      holidayDescription: description,
      holidayDate: toDate,
      dayOfHoliday: getDayOfWeek(toDate),
      holidayType: holidayType,
      isMandatory: true,
    };
    try {
      const result = await dispatch(
        updateHoliday({ id: editHolidayId, holidayData }),
      );
      //console.log("UPDATE RESULT =>", result);
      if (updateHoliday.fulfilled.match(result)) {
        //console.log("SUCCESS TOAST FIRED");

        dispatch(HRViewHoliday(year));
        setShowEditModal(false);
        resetForm();
      } else {
        toast.error(result?.payload?.message || result?.error?.message || "Failed to update holiday", { className: "toast-error-custom" });
      }
    } catch (error) {
      console.log("UPDATE ERROR =>", error);
      toast.error(error || "Something went wrong", { className: "toast-error-custom" });
    }
  };

  const resetForm = () => {
    setTitle("");
    setToDate("");
    setHolidayType("");
    setDescription("");
    setEditHolidayId(null);
    setIsEditMode(false);
  };

  const handlePublishHoliday = async (publishYear) => {
    try {
      const resultAction = await dispatch(
        publishHoliday(publishYear)
      );
      if (publishHoliday.fulfilled.match(resultAction)) {
        // Table refresh
        await dispatch(listOfCalendar(year));
        // Agar holiday list bhi refresh karni hai
        await dispatch(HRViewHoliday(publishYear));
      }
    } catch (error) {
      console.log("Publish API Error", error);
      toast.error(error || "Publish API Error", { className: "toast-error-custom" });
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const resultAction = await dispatch(deleteHoliday(holidayToDelete.id));
      if (deleteHoliday.fulfilled.match(resultAction)) {
        dispatch(HRViewHoliday(year));
        setShowDeleteModal(false);
      } else {
        toast.error(
          resultAction?.payload?.message ||
          resultAction?.error?.message ||
          "Failed to delete holiday", { className: "toast-error-custom" }
        );
      }
    } catch (error) {
      console.log("Delete API Error", error);
      toast.error(error || "Something went wrong", { className: "toast-error-custom" });
    }
  };

  const handleAddClick = () => {
    setFormMode("add");
    setFormData({ name: "", date: "", type: "" });
    setShowFormModal(true);
  };

  const handleEditClick = (holiday) => {
    setIsEditMode(true);
    setEditHolidayId(holiday.id);
    setTitle(holiday.holidayName || "");
    setToDate(holiday.holidayDate || "");
    setHolidayType(holiday.holidayType || "");
    setDescription(holiday.holidayDescription || "");
    setShowEditModal(true);
  };
  const [selectedYear, setSelectedYear] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const handleViewCalendar = async (viewYear) => {
    setSelectedYear(viewYear);
    setShowCalendar(true);

    await dispatch(HRViewHoliday(viewYear));
  };

  const handleEditCalendar = (editYear) => {
    dispatch(setSelectedEditYear(editYear));
    navigate("/admin/holidays-create");
  };

  const handleCreateCalendar = () => {
    navigate("/admin/holidays-create");
  };

  const handleDeleteClick = (holiday) => {
    setHolidayToDelete(holiday);
    setShowDeleteModal(true);
  };
  const handleFormSubmit = () => {
    if (formMode === "add") {
      // console.log("Adding new holiday:", formData);
    } else {
      // console.log("Updating holiday:", formData);
    }
    setShowFormModal(false);
  };

  // date format
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit", // optional
      hour12: true, // AM/PM
    });
  };
  const formatPublishDate = (createdAt, publishAt) => {
    if (!publishAt) return "-";
    const created = new Date(createdAt).getTime();
    const published = new Date(publishAt).getTime();

    // Same timestamp
    if (created === published) {
      return "-";
    }
    // Publish time is after create time
    if (published > created) {
      return new Date(publishAt).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit", // optional
        hour12: true,
      });
    }

    return "-";
  };

  const holidayLookup = useMemo(() => {
    return AllHoliday?.reduce((acc, holiday) => {
      if (holiday.holidayDate) {
        const dateObj = new Date(holiday.holidayDate);
        acc[
          `${year}-${dateObj.getMonth()}-${dateObj.getDate()}`
        ] = holiday.holidayName;
      }
      return acc;
    }, {});
  }, [AllHoliday, year]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [title, setTitle] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [holidayType, setHolidayType] = useState("");
  const [description, setDescription] = useState("");
  const [editHolidayId, setEditHolidayId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const canShowHolidayActions =
    HolidayStatus === "PUBLISHED"
      ? canManagePublishHoliday
      : (canManageHoliday || canManagePublishHoliday);

  const canDelete =
    HolidayStatus === "PUBLISHED"
      ? canDeletePublishHoliday
      : (canDeleteHoliday || canDeletePublishHoliday);

  const canEdit =
    HolidayStatus === "PUBLISHED"
      ? canManagePublishHoliday
      : (canManageHoliday || canManagePublishHoliday);

  const generateMonthDays = (monthIndex) => {
    const firstDay = new Date(year, monthIndex, 1).getDay();
    const totalDays = new Date(year, monthIndex + 1, 0).getDate();
    const today = new Date();

    let days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${monthIndex}-${i}`} className="empty"></div>);
    }

    for (let day = 1; day <= totalDays; day++) {
      const isToday =
        today.getFullYear() === year &&
        today.getMonth() === monthIndex &&
        today.getDate() === day;
      const holidayData = AllHoliday?.find((holiday) => {
        const holidayDate = new Date(holiday.holidayDate);
        return (
          holidayDate.getFullYear() === year &&
          holidayDate.getMonth() === monthIndex &&
          holidayDate.getDate() === day
        );
      });
      const isHoliday = holidayData;
      const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

      days.push(
        <div key={`day-${monthIndex}-${day}`} className={`day ${isToday ? "today" : ""} ${isHoliday ? "holiday" : ""}`}
          onClick={() => {
            if (!canManageHoliday) return;
            resetForm();
            setToDate(formattedDate);
            if (holidayData?.id) {
              dispatch(getHolidayById(holidayData.id));
            }
            setShowEditModal(true);
          }}>
          {" "}
          {day}{" "}
        </div>,
      );
    }
    return days;
  };
  return (
    <div className="container-fluid calendar-fluid calendar-box">
      <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: "18px" }}>
        <div className="icons-list">
          <Breadcrumb
            overrideTrail={[
              { name: "Dashboard", path: "/admin/dashboard" },
              { name: "Publish Calendars", }
            ]}
          />
          <div className="d-flex justify-content-end">
            <Button
              type="button"
              className="primary-btn ml-4"
              onClick={handleCreateCalendar}
            >
              Create Calendar
            </Button>
          </div>
        </div>
      </div>
      <div className="section-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="holidays-section card-body pt-0 mb-0">

                <div className="holidays-scroll-area">
                  {loading && (<p className="loading">Loading...</p>)}
                  {!loading && error && (<p className="server-error-msg">-- Unable to connect to server --</p>)}
                  {!loading && !error && (
                    <div className="user-role_section">
                      <div className="role-perm-tab">
                        <div className="role-data table-responsive mb-4">
                          <table className="year-container role-data-table table table-hover table-vcenter text-nowrap mb-0">
                            <thead>
                              <tr>
                                <th className="table-row">S.NO.</th>
                                <th className="table-row">Year</th>
                                <th className="table-row">Created Date</th>
                                <th className="table-row">Status</th>
                                <th className="table-row">Publish Date</th>
                                <th className="table-row">Action</th>
                              </tr>
                            </thead>
                            {(!calendarList || calendarList.length === 0) ? (
                              <tbody>
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    <p className="no-record-msg server-error-msg mb-0">
                                      -- No record found for Calendar --
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            ) : (
                              <tbody>
                                {calendarList?.map((holiday, index) => {
                                  //{calendarList?.map((holiday, index) => (
                                  const canEditCalendar = holiday.status === "PUBLISHED" ? canManagePublishHoliday : canManageHoliday;
                                  const menuActions = [
                                    {
                                      label: "View",
                                      icon: require("assets/img/view-icon.png"),
                                      permission: canManageHoliday,
                                      onClick: () => handleViewCalendar(holiday.year),
                                      show: true,
                                    },
                                    {
                                      label: "Edit Calendar",
                                      icon: require("assets/img/edit-icon.png"),
                                      title: canEditCalendar ? "Edit Calendar" : "No permission",
                                      permission: canEditCalendar,
                                      onClick: () => handleEditCalendar(holiday.year),
                                      show: canEditCalendar,
                                    },
                                    {
                                      label: "Publish Calendar",
                                      icon: require("assets/img/resend-link.png"),
                                      title: canManagePublishHoliday ? "Publish Calendar" : "No permisssion to Piblish Calendar",
                                      permission: canManagePublishHoliday,
                                      onClick: () => handlePublishHoliday(holiday.year),
                                      show:
                                        canManagePublishHoliday &&
                                        holiday.status !== "PUBLISHED",
                                    },
                                  ];
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td role="gridcell">{holiday.year ?? "-"}</td>
                                      <td className="rolename">
                                        {formatDate(holiday.createdAt)}
                                      </td>
                                      <td className="rolename">
                                        {holiday.status}
                                      </td>
                                      <td className="rolename">
                                        {formatPublishDate(holiday.createdAt, holiday.publishAt)}
                                      </td>
                                      <td className="action-column">
                                        <PopupState
                                          variant="popover"
                                          popupId="demo-popup-menu"
                                        >
                                          {(popupState) => (
                                            <>
                                              <button
                                                type="button"
                                                className="btn btn-icon btn-sm icons"
                                                {...bindTrigger(popupState)}
                                              >
                                                <img
                                                  src={require("assets/img/more.png")}
                                                  alt="more"
                                                  className="action-icon"

                                                />
                                              </button>

                                              <Menu {...bindMenu(popupState)}>
                                                {menuActions
                                                  .filter(
                                                    (action) => action.show,
                                                  )
                                                  .map((action, index) => (
                                                    <MenuItem
                                                      key={index}
                                                      title={action.title}
                                                      disabled={
                                                        !action.permission
                                                      }
                                                      onClick={() => {
                                                        popupState.close();
                                                        if (action.permission)
                                                          action.onClick();
                                                      }}
                                                      style={{
                                                        pointerEvents: 'auto',
                                                        cursor: action.permission ? 'pointer' : 'not-allowed'
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-icon btn-sm icons me-2"
                                                        disabled={
                                                          !action.permission
                                                        }
                                                        style={{ pointerEvents: !action.permission ? 'none' : 'auto' }}
                                                      >
                                                        <img
                                                          src={action.icon}
                                                          alt={action.label}
                                                          className="action-icon"
                                                          style={{
                                                            opacity:
                                                              action.permission
                                                                ? 1
                                                                : 0.5,
                                                            ...action.iconStyle
                                                          }}
                                                        />
                                                      </button>
                                                      {action.label}
                                                    </MenuItem>
                                                  ))}
                                              </Menu>
                                            </>
                                          )}
                                        </PopupState>
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            )}
                          </table>
                        </div>
                      </div>
                    </div>)}
                </div>
                {showCalendar && (
                  <div className="view-calendar">
                    <div className="d-flex justify-content-between align-items-center">
                      {/* <div style={{ cursor: "pointer" }} onClick={() => { setYear(year - 1); navigate(`/admin/holidays-publish/${year - 1}`); }}>
            <Button type="button" className="primary-btn" >
              <i className="fas fa-chevron-left"></i> {year - 1}
            </Button>
          </div> */}
                      <div className="align-items-center">
                        <h5 className="mb-0">Holidays Calendar - {selectedYear},
                          <label className="mb-0">
                            Status: - {HolidayStatus ?? "This year's calendar has not been created yet"}
                          </label>
                        </h5>
                      </div>
                      {/* <div style={{ cursor: "pointer" }} onClick={() => { setYear(year + 1); navigate(`/admin/holidays-publish/${year + 1}`); }}>
            <Button type="button" className="primary-btn ml-4" >
              {year + 1} <i className="fas fa-chevron-right"></i>
            </Button>
          </div> */}
                    </div>
                    <div className="holidays-grid mt-3">
                      {AllHoliday?.map((holiday) => {
                        const uniqueId = `holiday-${holiday.id}`;
                        const menuActions = [
                          {
                            label: "Edit",
                            icon: require("assets/img/edit-icon.png"),
                            permission: canEdit,
                            show: canEdit,
                            onClick: () => handleEditClick(holiday),
                          },
                          {
                            label: "Delete",
                            icon: require("assets/img/delete.png"),
                            permission: canDelete,
                            show: canDelete,
                            onClick: () => handleDeleteClick(holiday),
                          },
                        ];

                        return (
                          <div key={uniqueId} className="holiday-item"
                            style={{
                              border: "1px solid #e0e0e0",
                              borderLeft: "4px solid #6f42c1",
                              borderRadius: "4px",
                              backgroundColor: "#fff",
                              overflow: "hidden",
                              display: "flex",
                              flexDirection: "column",
                              alignSelf: "start",
                            }}
                          >
                            <div className="holiday-header d-flex justify-content-between align-items-center p-0" onClick={() => toggleHoliday(uniqueId)} style={{ cursor: "pointer" }} >
                              <span
                                style={{ fontWeight: "500", color: "#333", fontSize: "14px", }}>
                                {holiday.holidayName}
                              </span>

                              <div className="d-flex align-items-center">
                                <span className="me-2 text-muted" style={{ fontSize: "14px" }}>
                                  {holiday.holidayDate}
                                </span>
                                {canShowHolidayActions && (
                                  <div onClick={(e) => e.stopPropagation()}>
                                    <PopupState variant="popover" popupId={`popup-${uniqueId}`}>
                                      {(popupState) => (
                                        <>
                                          <button type="button" className="btn btn-icon pt-0 pb-0 btn-sm" style={{ border: "none", background: "transparent", }} {...bindTrigger(popupState)}>
                                            <img src={require("assets/img/more.png")} alt="more" style={{ width: "14px", opacity: 0.6 }} />
                                          </button>
                                          <Menu {...bindMenu(popupState)}>
                                            {menuActions
                                              .filter((action) => action.show)
                                              .map((action, index) => (
                                                <MenuItem
                                                  key={index}
                                                  disabled={!action.permission}
                                                  onClick={() => {
                                                    popupState.close();
                                                    if (action.permission)
                                                      action.onClick();
                                                  }}
                                                >
                                                  <button type="button" className="btn btn-icon btn-sm icons me-2 asasas"
                                                    title={
                                                      action.permission
                                                        ? action.label
                                                        : "No permission"
                                                    }
                                                    disabled={!action.permission}
                                                  >
                                                    <img src={action.icon} alt={action.label} className="action-icon" style={{ opacity: action.permission ? 1 : 0.5, }} />
                                                  </button>
                                                  {action.label}
                                                </MenuItem>
                                              ))}
                                          </Menu>
                                        </>
                                      )}
                                    </PopupState>
                                  </div>
                                )}
                                <i className={`ms-2 fas ${expandedHoliday === uniqueId ? "fa-chevron-up" : "fa-chevron-down"}`} style={{ fontSize: "12px", color: "#ccc" }}></i>
                              </div>
                            </div>

                            {expandedHoliday === uniqueId && (
                              <div style={{ padding: "12px 16px", borderTop: "1px solid #f0f0f0", backgroundColor: "#fafafa", }}>
                                <p style={{ margin: "0", fontSize: "13px", color: "#6c757d", lineHeight: "1.5", }}>
                                  {holiday.holidayDescription || "No description available for this holiday."}
                                </p>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* <div className="calendar-container mt-4">
        <h3 className="year-heading">{year}</h3>
        <div className="year-grid">
          {months.map((month, index) => (
            <div key={month} className="month">
              <h5>{month}</h5>
              <div className="weekdays">
                {daysOfWeek.map((day) => (
                  <div key={day} className="weekday">
                    {day}
                  </div>
                ))}
              </div>
              <div className="days-grid">{generateMonthDays(index)}</div>
            </div>
          ))}
        </div>
      </div> */}
            </div>
          </div>
        </div>
      </div>
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Update Holiday" : "Add Holiday"}
          </Modal.Title>
          <button onClick={() => setShowEditModal(false)} className="modal-close">
            <img src={CrossIcon} alt="Close" style={{ width: "20px", height: "20px" }} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Holiday Type</Form.Label>
              <Form.Select value={holidayType} onChange={(e) => setHolidayType(e.target.value)} style={{ height: "38px" }}>
                <option value="">Select holiday type</option>
                <option value="NATIONAL_HOLIDAY">National Holiday</option>
                <option value="FESTIVAL_HOLIDAY">Festival Holiday</option>
                <option value="COMPANY_HOLIDAY">Company Holiday</option>
                <option value="REGIONAL_HOLIDAY">Regional Holiday</option>
                <option value="RESTRICTED_HOLIDAY">
                  Restricted Holiday (RH)
                </option>
                <option value="SPECIAL_HOLIDAY">Special Holiday</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                placeholder="Enter description"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="cancel-cta" onClick={() => setShowEditModal(false)}>
            Close
          </Button>
          <Button
            variant="update-cta"
            onClick={() => {
              if (isEditMode) {
                handleUpdateHoliday();
              } else {
                handleAddHolidaySubmit();
              }
            }}
          >
            {isEditMode ? "Update Holiday" : "Add Holiday"}
          </Button>
        </Modal.Footer>
      </Modal>

      <HolidayFormModal
        show={showFormModal}
        onHide={() => setShowFormModal(false)}
        mode={formMode}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        canEdit={true}
      />
      <DeleteHolidayModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={handleDeleteConfirm}
        holidayName={holidayToDelete?.name || ""}
      />
      <ToastContainer />
    </div>
  )
}

export default PublishHoliday
